import DialpadIcon from '@material-ui/icons/Dialpad';
import WeeklySubscriptionDrawCreate from './WeeklySubscriptionDrawCreate';
import WeeklySubscriptionDrawEdit from './WeeklySubscriptionDrawEdit';
import WeeklySubscriptionDrawList from './WeeklySubscriptionDrawList';
import WeeklySubscriptionDrawShow from './WeeklySubscriptionDrawShow';
import WeeklySubscriptionDrawView from './WeeklySubscriptionDrawView';

export default {
  list: WeeklySubscriptionDrawList,
  create: WeeklySubscriptionDrawCreate,
  edit: WeeklySubscriptionDrawEdit,
  show: WeeklySubscriptionDrawView,
  icon: DialpadIcon,
};
